import { faFilterCircleDollar } from "@fortawesome/free-solid-svg-icons"
import { BsFillCartFill, BsHeadset } from "react-icons/bs"

export const businessMetrics = [
  {
    label: "Inq Conv",
    value: "72.5%",
    color: "var(--sahi-green)",
  },
  {
    label: "Order Growth",
    value: "+18.3%",
    color: "var(--sahi-blue)",
  },
  {
    label: "Punctuality",
    value: "94.2%",
    color: "var(--sahi-orange)",
  },
  {
    label: "Avg Order",
    value: `45K`,
    color: "var(--text-color)",
  },
];

export const customerData = {
    active: 20,
    inactive: 30,
    future: 40,
}

export const supplierData = {
    active: 20,
    inactive: 30,
    future: 40,
}

export const customerContractsData = {
    active: 12,
    expiring: 2,
    renewed: 16,
    new: 18,
}

export const supplierContractsData = {
    active: 9,
    expiring: 13,
    renewed: 15,
    new: 16,
}

// Today's tasks dummy data (keeping original structure)
export const processedData = {
todayTasks: [
    {
    Ttl: "Follow up with ABC Corp",
    bizName: "ABC Corporation",
    DT: "2024-01-08T10:30:00",
    Pri: "H",
    connID: 1,
    type: "Call", // Added type
    },
    {
    Ttl: "Review supplier contract",
    bizName: "XYZ Suppliers",
    DT: "2024-01-08T14:00:00",
    Pri: "M",
    connID: 2,
    type: "Review", // Added type
    },
    {
    Ttl: "Customer support call",
    bizName: "Tech Solutions Ltd",
    DT: "2024-01-08T16:15:00",
    Pri: "L",
    connID: 3,
    type: "Call", // Added type
    },
],
overdueTasks: [
    {
    Ttl: "Send proposal by Email",
    bizName: "ABC Traders Pvt. Ltd.",
    DT: "2024-01-05T09:00:00",
    Pri: "H",
    connID: 4,
    type: "Email", // Added type
    },
    {
    Ttl: "Follow-up for payment",
    bizName: "DEF Traders Pvt. Ltd.",
    DT: "2024-01-06T11:00:00",
    Pri: "M",
    connID: 5,
    type: "Follow-up", // Added type
    },
],
thisWeekTasks: [
    {
    Ttl: "Prepare Q1 financial report",
    bizName: "Finance Department",
    DT: "2024-01-10T09:00:00",
    Pri: "H",
    connID: 6,
    type: "Report", // Added type
    },
    {
    Ttl: "Team meeting agenda",
    bizName: "Internal",
    DT: "2024-01-09T10:00:00",
    Pri: "L",
    connID: 7,
    type: "Meeting", // Added type
    },
],
}

// Business activities data
export const businessActivities = [
{
    id: 1,
    name: "Sales Inquiries",
    icon: faFilterCircleDollar,
    iconType: "fontawesome",
    color: "var(--sahi-green)",
    open: 12,
    delayed: 3,
    value: "8,500",
},
{
    id: 2,
    name: "Sales",
    icon: BsFillCartFill,
    iconType: "react",
    color: "var(--sahi-green)",
    open: 17,
    delayed: 20,
    value: "23,000",
},
{
    id: 3,
    name: "Customer Tickets",
    icon: BsHeadset,
    iconType: "react",
    color: "var(--sahi-green)",
    open: 6,
    delayed: 7,
    value: "300",
},
{
    id: 4,
    name: "Purchase Inquiries",
    icon: faFilterCircleDollar,
    iconType: "fontawesome",
    color: "var(--sahi-orange)",
    open: 8,
    delayed: 2,
    value: "5,200",
},
{
    id: 5,
    name: "Purchase Orders",
    icon: BsFillCartFill,
    iconType: "react",
    color: "var(--sahi-orange)",
    open: 14,
    delayed: 18,
    value: "31,500",
},
{
    id: 6,
    name: "Supplier Complaints",
    icon: BsHeadset,
    iconType: "react",
    color: "var(--sahi-orange)",
    open: 3,
    delayed: 5,
    value: "150",
},
]

// Updated Leaderboard data with price and orders
export const leaderboardData = [
    {
        id: 1,
        name: "John Smith",
        department: "Sales",
        score: 95,
        price: 5200,
        orders: 45,
    },
    {
        id: 2,
        name: "Sarah Johnson",
        department: "Customer Support",
        score: 88,
        price: 4800,
        orders: 38,
    },
    {
        id: 3,
        name: "Mike Davis",
        department: "Procurement",
        score: 82,
        price: 4100,
        orders: 32,
    },
    // {
    //     id: 4,
    //     name: "Lisa Brown",
    //     department: "Sales",
    //     score: 78,
    //     price: 3900,
    //     orders: 29,
    // },
    // {
    //     id: 5,
    //     name: "Tom Wilson",
    //     department: "Operations",
    //     score: 75,
    //     price: 3600,
    //     orders: 25,
    // },
    // {
    //     id: 6,
    //     name: "Emma Taylor",
    //     department: "Customer Support",
    //     score: 72,
    //     price: 3200,
    //     orders: 22,
    // },
]

